export enum ApiSearchTypesEnum {
  Product = 'PRODUCT',
  Installer = 'INSTALLER',
  Architect = 'ARCHITECT',
  Developer = 'PROJECT_OWNER',
  Business = 'BUSINESS',
  Tender = 'TENDER',
  Auction = 'AUCTION',
}
